import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import { getScheduledTaskById } from '../../redux/actions/tasks';
import { Task } from '../../types';
import { StoreState } from '../../types/state';
import EntityData from '../Common/EntityData';
import ExecutionLog from './ExecutionLog';
import RunTask from './RunTask';

const ScheduledTaskDetails = () => {
  const { id } = useParams<{ id: string }>();
  const task: Task = useSelector((state: StoreState) => {
    return state.tasks.scheduledTasks[id];
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (!task) {
      dispatch(getScheduledTaskById(id));
    }
  }, [task, id, dispatch]);

  return (
    <div>
      <Header>Scheduled Task Details</Header>
      <EntityData entity={task} />
      <RunTask id={id} />
      <ExecutionLog taskId={id} />
    </div>
  );
};

export default ScheduledTaskDetails;
